import { makeAutoObservable } from "mobx";
import { ErrorStack, errorStack } from "./ErrorStack";

export class ErrorManager {
  public errorStack: ErrorStack = errorStack;
  public openErrors: boolean = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  public setOpenErrors(open: boolean) {
    this.openErrors = open;
  }
}
